module.exports = __webpack_public_path__ + "static/media/Fondo_Felicitaciones.d186cf7b.png";